import { Authorization, JwtUser } from '@pimm/services/lib/access';

export interface AppState {
  authorization?: Authorization;
  user?: JwtUser;
}

export const AppEmptyState: AppState = {};
